<template>
  <multi-selector v-model="batchs" :filterable="true" :options="batchNoList" :remote="searchBatchList"></multi-selector>
</template>
<script>
import MultiSelector from '../Select';

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    batchNo: {
      type: Array,
      default() {
        return [];
      }
    },
    testing: {
      type: null
    },
    batchId: {
      type: null
    }
  },
  data() {
    return {
      batchs: [],
      batchNoList: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getBatchNo();
    });
  },
  watch: {
    batchs() {
      this.$emit('input', this.batchs.map(item => item.id));
    },
    batchNo(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.searchByBatchId(newVal);
      }
    }
  },
  methods: {
    // 批次号下拉框
    getBatchNo() {
      const val = '';
      this.$ajax({
        url: '/robotCase/getBatchDataList',
        params: { 'val': val, 'testing': this.testing, 'batchId': this.batchId }
      }).then((res) => {
        this.batchs = [];
        this.batchNoList = this.optionsHandler(res.data);
        this.batchNoList.forEach((item) => {
          if (this.batchNo.indexOf(item.id) !== -1) {
            this.batchs.push(item);
          }
        });
      });
    },
    // 批次号搜索
    searchBatchList(val) {
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: '/robotCase/getBatchDataList',
          params: { 'val': val, 'testing': this.testing, 'batchId': this.batchId }
        }).then((res) => {
          console.warn('批次号');
          console.warn(this.batchs);
          this.batchNoList = this.optionsHandler(res.data);

          const self = this;
          this.batchNoList.forEach((item) => {
            if (self.batchNo.indexOf(item.id) !== -1) {
              if (self.batchs.length > 0) {
                self.batchs.forEach((it) => {
                  if (item.batchNo === it.batchNo) {
                    self.batchs.splice(it, 1);
                  }
                  self.batchs.push(item);
                });
              }
            } else if (self.batchs.length > 0) {
              const list = [];
              self.batchs.forEach((it) => {
                if (item.batchNo !== it.batchNo) {
                  list.push(it);
                } else {
                  list.push(item);
                }
              });
              self.batchs = list;
            }
          });
          resolve();
        }).catch((err) => {
          reject(err);
        });
      });
    },
    searchByBatchId(val) {
      if (val.length > 1) {
        return;
      }
      this.$ajax({
        url: `/robotCase/searchByBatchId?val=${val}`
        // params: { 'val': val }
      }).then((res) => {
        if (res.data !== null && res.data.length > 0) {
          const batch = this.optionsHandler(res.data);
          batch.forEach((item) => {
            const matched = this.batchNoList.filter(b => b.id === item.id);
            if (matched.length === 0) {
              this.batchNoList.push(item);
              // this.batchs.unshift(item);
              this.batchs = [item];
            }
          });
        }
      });
    },
    optionsHandler(options) {
      return options.map((element) => {
        element.title = `${element.companyName.substring(0, 6)}...(${element.batchNo})`;
        return element;
      });
    }
  },
  components: {
    MultiSelector
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness-select/BatchSelector.vue